// French to English Mapping 
var inputMapping = {'Forme': 'Shape','Prix': 'Price','Style': 'Style','Métal': 'Metal'};

// English to French translations for filter keys
var filterKeyTranslations = {'Shape': 'Forme','Metal': 'Métal','Style': 'Style','Price': 'Prix'};

var shapeTranslation = {
  "Rond": "Round",
  "Princesse": "Princess",
  "Oval": "Oval",
  "Poire": "Pear",
  "Emeraude": "Emerald",
  "Coussin": "Cushion",
  "Asscher": "Asscher",
  "Radiant": "Radiant",
  "Coeur": "Heart",
  "Marquise": "Marquise"
};

var metalTranslation = {
  "Or Blanc 14K": "14K White Gold",
  "Or Jaune 14K": "14K Yellow Gold",
  "Or Rose 14K": "14K Rose Gold",
  "Or Blanc 18K": "18K White Gold",
  "Or Jaune 18K": "18K Yellow Gold",
  "Or Rose 18K": "18K Rose Gold",
  "Platine": "Platinum"
};

var styleTranslation = {
  "Solitaire": "Solitaire",
  "Halo": "Halo",
  "Éternité": "Eternity",
  "Accentué": "Accented",
  "Trois Pierres": "Three Stone",
  "Lunette": "Bezel",
  "Sculpturale": "Sculptural",
  "Tige Fendue": "Split Stem",
  "Deux Pierres": "Two Stone",
  "Infini": "Infinity",
  "Ancienne": "Vintage",
  "By-pass": "Bypass"
};

/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); (i < 500 && i<maxDiamondPrice); i = i+10) {
    price.push(i);
  };
  for (var i = 500; (i < 1000 && i<maxDiamondPrice); i = i+15) {
    price.push(i);
  };
  for (var i = 1000; (i < 1500 && i<maxDiamondPrice); i = i+20) {
    price.push(i);
  };
  for (var i = 1500; (i < 2000 && i<maxDiamondPrice); i = i+25) {
    price.push(i);
  };
  for (var i = 2000; (i < 3000 && i<maxDiamondPrice); i = i+30) {
    price.push(i);
  };
  for (var i = 3000; (i < 4000 && i<maxDiamondPrice); i = i+35) {
    price.push(i);
  };
  for (var i = 4000; (i < 4500 && i<maxDiamondPrice); i = i+40) {
    price.push(i);
  };
  for (var i = 4500; (i < 5000 && i<maxDiamondPrice); i = i+45) {
    price.push(i);
  };
  // for (var i = 5000; i < 25000; i = i+50) {
  //   price.push(i);
  // };
  // for (var i = 25000; i < 50000; i = i+100) {
  //   price.push(i);
  // };
  // for (var i = 50000; i < 80000; i = i+200) {
  //   price.push(i);
  // };
  // for (var i = 80000; i < 100000; i = i+1000) {
  //   price.push(i);
  // };
  // for (var i = 100000; i < 200000; i = i+1000) {
  //   price.push(i);
  // };
  
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);  
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
  
function price_slider_render(min_price,max_price,option,filterLabel){
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              emptyProductResultDiv();         
              if(option == true) {                         
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end                               

                 if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    ajaxDataCall();
                 }
                 slide = '';
                 return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);

                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val(''); 
                     setTimeout(function(){
                       ajaxDataCall();
                     }, 10);
                   }

                   setTimeout(function(){
                     option = true;
                   }, 25); 
                   slide = '';
                   
                   return false;
                }
            }
             
        });
  		  
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);  		 
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_max_price);
		return false;
	} else {
		var price_min = jQuery('#price_from').val();
	}
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
	var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
	if (isNaN(price_min_value) != false) {    
        alert(translations.titlePleaseEnterValueInNumber);  
		jQuery('#price_from').val(formatted_min_price);
        return false;
	} else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);		
		jQuery('#price_from').val(formatted_min_price);
		return false;
	} else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
		price_slider_render(default_price_min, price_max_value, false, filterLabel);
		return false;
	}

	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
	if ($('#price_to').val() == ''){
		var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		$('#price_to').val(formatted_min_price);        
		return false;
	} else {
		var price_max = $('#price_to').val();        
	}

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
	if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
		jQuery('#price_to').val(formatted_max_price);
        return false;
	} else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value == '') {
		jQuery('#price_from').val(price_min_value);
	}

	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);
}

function getPriceWithoutSymbolAndCommas(input_price) {
  var price = input_price;
  if(input_price.indexOf("€") >= 0){
    price = input_price.replace('€', '');
    price = price.replace(/[^\d\.]/g, '');
  }else if(input_price.indexOf("$") >= 0){
    price = input_price.replace('$', '');
    price = price.replace(/\./g, '');   
  }
  return price;
}
/*** Diamond Price Filter End ***/

/*** Sort Filter Start ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyProductResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  
  jQuery('#sort_by').val(sort_by);

  jQuery('.tps-sort-by-value').html('<span>'+sort_title+'</span>');
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sort_by).addClass('active');
  
  jQuery('#page_no').val(1);
  
  ajaxDataCall(); 
  
  updateSessionFilters(session_variable+'-other-data','Sort-By',sort_by);
  updateSessionFilters(session_variable+'-other-data','Sort-Title',sort_title);
});
/*** End ***/

/*** Set Session Selected Sort Filter Start ***/
function setSessionSelectedSortValues(sortBy,sortTitle) {  
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sortBy).addClass('active');  

  jQuery('.tps-sort-by-value').html(sortTitle);
}
/*** Set Session Selected Sort Filter End ***/

/*** CheckBox Type Filter Selection Common Function Start ***/
function setSettingCheckboxtypeFilter(ele,parentClass,valueid,filter){  
     var filter_value = jQuery(ele).find("input").attr('data-value');
     var filterLable = filter; 
      filterLable = inputMapping[filterLable] || filterLable;
      
     emptyProductResultDiv();
  
     if(jQuery(ele).hasClass('selected')){
        filter_value = '';
        jQuery(ele).removeClass('selected');
        $('#'+valueid).val('');
     }else{     
        jQuery('.tps-filter-'+filterLable.toLowerCase()+'-li').removeClass('selected');
        jQuery(ele).addClass('selected');
         $('#'+valueid).val(filter_value);
     }  
       
    jQuery('#page_no').val(1);
    ajaxDataCall();
    updateSessionFilters(session_variable+'-filters',filter, filter_value);
  
    // Convert French input to English if exists
    var filter = inputMapping[filter] || filter;
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSettingSelectedFilter(filterTitle,filterFunction,hasClass,filterLable);
    //end  
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Metal Filter From Applied Filter Start ***/
function removeMetalFilter(metal){ 
  // Clear all query parameters from the URL
  var baseUrl = window.location.origin + window.location.pathname;

  // Store cleaned URL in global variable
  tps_config_setting_listing = baseUrl;

  // Update the URL in browser without reloading
  window.history.replaceState({}, '', baseUrl);
  console.log("tps_config_setting_listing",tps_config_setting_listing)
  if (localStorage.getItem('tps_config_setting_listing') === null) {
      // Key doesn't exist – create it
      localStorage.setItem('tps_config_setting_listing', tps_config_setting_listing);
      console.log('Created localStorage key: tps_config_setting_listing');
  } else {
      // Key exists – update its value
      localStorage.setItem('tps_config_setting_listing', tps_config_setting_listing);
      console.log('Updated localStorage key: tps_config_setting_listing');
  }
  jQuery('.tps-filter-metal-list input[data-value="'+metal+'"]').click();
}
/*** Remove Metal Filter From Applied Filter End ***/

/*** Remove Style Filter From Applied Filter Start ***/
function removeStyleFilter(style){ 
  jQuery('.tps-filter-style-list input[data-value="'+style+'"]').click();
}
/*** Remove Style Filter From Applied Filter End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSettingSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {    

  // Convert French input to English if exists
  input_value = inputMapping[input_value] || input_value;

  // Ensure consistent matching by handling case-insensitive inputs
  input_value = input_value.toLowerCase();
  
	if (input_value == 'price') {
		$('.tps-selected-filter-container').find('li[data-input="price"]').remove();
	}else if (input_value == 'shape') {     
		$('.tps-selected-filter-container').find('li[data-input="shape"]').remove();
	}else if (input_value == 'style') {
		$('.tps-selected-filter-container').find('li[data-input="style"]').remove();
	}else if (input_value == 'metal') {
		$('.tps-selected-filter-container').find('li[data-input="metal"]').remove();
    }
  
	var value = filter_value.split(':');
   
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();

        // Translate filter key to French if available
        var filterKeyInFrench = filterKeyTranslations[value[0]] || value[0];
      
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter-value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
		if ($('#' + value[0] + '-container').length > 0) {
			$('#' + value[0] + '-container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + filterKeyInFrench + ':</span></ul>';
			$('.tps-selected-filter-container').append(elecontainer);
			$('#' + value[0] + '-container').append(html);
		}    
	} else {
		$('.tps-selected-filter-container').find('li[data-filter-value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
            $('input[value="' + input_value + '"]').removeClass('selected');
		}

		if ($('#' + value[0] + '-container li').length == 0) {
			$('#' + value[0] + '-container').remove();
		}
	}
	if ($('.tps-selected-filter-container li').length > 0) {
		$('.tps-selected-filter-wrapper').show();
	} else {
		$('.tps-selected-filter-wrapper').hide();
	}
}
/*** Set selected filters for session filters after reloading page end ***/

/*** Insert Session Selected Values In Input Fields Start ***/
// Helper function to handle case-insensitive mapping
function getInputKey(key) {
  return inputMapping[key] || key;
}
function getSessionSelectedSettingFilterValues(session_data) {  
  
  $.each(session_data, function(key,value){ 

    var inputKey = getInputKey(key);
    
    if(inputKey == 'Shape' || inputKey == 'Metal' || inputKey == 'Style'){    
        if(value != ''){
          var inputValues = value.toString();          
          $('#setting_'+inputKey.toLowerCase()).val(inputValues);
    
          var filterArrayKey = inputKey;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedSettingCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(inputKey == 'Price'){
      $('#'+inputKey.toLowerCase()+'_left_hidden').val(value[0]);
      $('#'+inputKey.toLowerCase()+'_right_hidden').val(value[1]);
    }
     
  });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedSettingCheckBoxFilters(filterKey,filterValues) {
      // Ensure filterValues is always an array and split if it's a string with commas
      if (typeof filterValues === "string") {
          filterValues = filterValues.split(",").map(item => item.trim());
      } else if (!Array.isArray(filterValues)) {
          filterValues = [filterValues];
      }  

    // Process each filter value separately
    filterValues.forEach((value) => {
        var filterTitle = filterKey.toLowerCase();
        var filterValue = value.toLowerCase();


      if(filterTitle != 'shape'){
        filterValue = filterValue.replace(/\s+/g, '-');
      }

        var checkboxSelector = ".tps-filter-" + filterTitle + "-checkbox-" + filterValue;
        var filterClassSelector = ".tps-filter-" + filterTitle + "-" + filterValue;

        if ($(checkboxSelector).length > 0) {
            $(checkboxSelector).prop("checked", true);

            setTimeout(() => {
                var applySelectedClass = setInterval(() => {
                    if ($(filterClassSelector).length > 0) {
                        $(filterClassSelector).addClass("selected");
                        clearInterval(applySelectedClass);
                    }
                }, 100);
            }, 100);
          
        } 

        // Prepare filter value for UI
        var filterSelectedValues = filterKey + ': ' + value;

        // Apply the filter to the UI (calls setSelectedFilter to render filter badges)
        setSettingSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,filterTitle);
    });
  
}
/*** Set Session Selected Checkbox Type Filters End ***/

// function getQueryParamNew(name) {
//   const urlParams = new URLSearchParams(window.location.search);
//   return urlParams.get(name);
// }


/*** Get All Setting Products Start ***/ 
function ajaxDataCall() {
  
  jQuery(".tps-productlist-result-grid-view-loader").show();
  jQuery("#tps_product_count").html("(<span class='tps-product-count-loader'></span>)");
    console.log("AjaxDataCall Triggered");
  let prodGridView = '';

  // Dynamically set session_flag
    var session_key = session_variable + '-other-data';
    var sessionData = localStorage.getItem(session_key)
    sessionData = sessionData ? JSON.parse(sessionData) : {};
    let session_flag = (sessionData && sessionData['Ring-Id'] && sessionData['Ring-Id'][0]) ? 1 : 0;


  // Define collection handle
  var collectionHandle = jQuery("#collectionHandle").val() || '';

  var productsPerPage = parseInt(document.querySelector('#products_per_page').value);
  let page_no = parseInt(jQuery('#page_no').val());

  let showFrom = 0;
  let showTo = 0;

  if (session_flag !== 0) {
    var recentPageNo = session_other_data['Recent-Product-Page-No'][0];
    jQuery("#page_no").val(recentPageNo);
    page_no = recentPageNo;
    var productShow = recentPageNo * productsPerPage;
    showFrom = 0;
    showTo = parseInt(productShow) - 1;
  } else {
    var productShow = page_no * productsPerPage;
    showFrom = productsPerPage * (page_no - 1);
    showTo = parseInt(showFrom) + parseInt(productsPerPage) - 1;
  }

  var setting_shape_french = jQuery("#setting_shape").val();
  var setting_metal_french = jQuery("#setting_metal").val();
  var setting_style_french = jQuery("#setting_style").val();

  var sort_by = jQuery('#sort_by').val();
  var orderby = jQuery('#sort_dir').val();
  var price_min = jQuery("#price_left_hidden").val();
  var price_max = jQuery("#price_right_hidden").val();
  var setting_shape = translateFilterValues(setting_shape_french, shapeTranslation);
  var setting_metal = translateFilterValues(setting_metal_french, metalTranslation);
  var setting_style = translateFilterValues(setting_style_french, styleTranslation);
  if(setting_style == "Split Stem") {
    setting_style = setting_style.toLowerCase();
  } else {
    setting_style = setting_style.toLowerCase().replace(/\s+/g, '-'); 
  }
  var bulk_page_data = getBulkPageDataValuesFromSession();

  var diamonds_display_per_page = (jQuery(window).width() > 900 && jQuery(window).width() < 1198) ? 39 : 60;

  var postdata = JSON.stringify({ query:`{
                  ${ringdata}(page: "` +
              page_no +
              `", pageSize:"`+diamonds_display_per_page+`", shapes:"` +
              setting_shape +
              `", styles:"`+ setting_style +`", metals:"` +
              setting_metal +
              `", price:"` +
              price_min +
              `, ` +
              price_max +
              `", bulkPageData:"`+bulk_page_data+`", sortBy:"`+ sort_by +`")
                  {
                      dataCount
                      ringsReturned
                      pageNo
                      ring {
                          ringId
                          sku
                          description
                          shortDescription
                          groupDescription
                          merchandisingCategory1
                          merchandisingCategory2
                          merchandisingCategory3
                          merchandisingCategory4
                          merchandisingCategory5
                          productType
                          onhand
                          status
                          price
                          showcasePrice
                          currency
                          unitOfSale
                          Video
                          finalPriceEur
                          weightInDwt
                          weightUnitOfMeasure
                          gramWeight
                          ringSizable
                          ringSize
                          ringSizeType
                          leadTime
                          productId
                          designOption
                          type
                          jewelryState
                          quality
                          primaryStoneType
                          primaryStoneShape
                          primaryStoneSize
                          secondaryStoneType
                          finishedState
                          readyToWear
                          stoneMapImage
                          diamondClarity
                          diamondColor
                          totalDiamondCaratWeight
                          countryOfOrigin
                          qualityCatalogValue
                          creationDate
                          updatedAt
                          style
                          image1
                          image2
                          image3
                          FullySetImage1
                          FullySetImage2
                          FullySetImage3
                          FullySetImage4
                          FullySetImage5
                      }
                      }
                    }
                  `});   

  abortAjax(xhr);

  xhr = $.ajax({
    type: 'POST',
    url: api,
    contentType: 'application/json',
    data: postdata,
    success: function (response) {
     var ringResponse = response?.data?.[ringdata];
      console.log(response);
      if (!ringResponse || !Array.isArray(ringResponse.ring) || ringResponse.ring.length === 0) {
        jQuery('.tps-productlist-result-grid-view-loader').hide();
        jQuery('.tps-productlist-result-grid-view-items-list').html(
          '<span class="tps-no-product-found">' + translations.titleNoProductFound + 
          ' <a class="tps-reset-filter tps-reset-popup" onclick="resetFilters(\'all\')">Reset Filters</a></span>'
        ).addClass('tps-no-product-found');
        jQuery("#tps_product_count").html("(0)");
        jQuery(".tps-total-products-displays").html("0");
        jQuery(".tps-load-more-button-section").hide()
        return;
      }

      var productsData = ringResponse.ring;
      var productCount = productsData.length;
      jQuery("#tps_product_count").html("(" + addCommas(ringResponse.dataCount) + ")");
      jQuery("#total_products_count").val(ringResponse.dataCount);
      jQuery(".tps-total-products").html(addCommas(ringResponse.dataCount));
      if (productCount > 0) {
        $('.tps-product-grid-view-container').removeClass('tps-no-product');

          $.each(productsData, function (index, product) {
            // Check if li with same data-id already exists
            var productId = product?.productId;
            var existingProduct = jQuery('.tps-productlist-result-grid-view-items-list li[data-id="' + productId + '"]');
            
            if (existingProduct.length === 0) {
              // Only add if not already present
              prodGridView += getProductGridViewLayout(product, collectionHandle, index);
            }
          });

        
        // $.each(productsData, function (index, product) {
        //   prodGridView += getProductGridViewLayout(product, collectionHandle, index);
        // });

        jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);
      } 

      var totalReturnedSoFar = jQuery(".tps-productlist-result-grid-view-items-list > li").length;

      if (totalReturnedSoFar >= ringResponse.dataCount) {
        jQuery(".tps-load-more").hide().addClass("load-more-active");
      } else {
        jQuery(".tps-load-more").show().removeClass("load-more-active");
        jQuery('#page_no').val(page_no + 1);
      }

      jQuery('.tps-total-products-displays').html(addCommas(totalReturnedSoFar));

      // if (session_flag !== 0) {
      //   var recentProduct = session_other_data['Ring-Id'][0];
      //   focusRecentProduct(recentProduct);
      // }
      var session_variable = jQuery("#session_variable").val(); // like "ringbuilder-setting"
      var session_other_data = JSON.parse(localStorage.getItem(session_variable + '-other-data'));
      
      if (session_other_data && session_other_data['Ring-Id'] && session_other_data['Ring-Id'][0]) {
        var recentRingId = session_other_data['Ring-Id'][0];
        focusRecentRing(recentRingId); // No view_type needed
      }

      jQuery(".tps-productlist-result-grid-view-loader").hide();
    }
  });
}

/*** Get All Setting Products End ***/ 

/*** Focus Recently View Diamond Start ***/

// function focusRecentProduct(ring_id) {
//   console.log("product_id", ring_id);
//   var target = '.product-grid-item-' + ring_id;
//   var $target = $(target);

//   if ($target.length > 0) {
//     $target.addClass('tps-productlist-result-grid-view-item');
//     $('html, body').animate({
//       scrollTop: $target.offset().top - 300
//     }, 'slow');

//     setTimeout(function () {
//       $target.removeClass('tps-productlist-result-grid-view-item');
//     }, 1000);
//   } else {
//     console.warn("Target element not found for selector:", target);
//   }
// }
function focusRecentRing(ring_id) {
  var target = '.product-grid-item-' + ring_id;
  var $targetElement = $(target);

  if ($targetElement.length > 0) {
    // Highlight the item
    $targetElement.addClass('tps-recent-viewed-ring');

    // Smooth scroll to it
    $('html, body').animate({
      scrollTop: $targetElement.offset().top - 300
    }, 'slow');

    // Clear localStorage values
    updateSessionFilters(session_variable + '-other-data', 'Ring-Id', '');
    updateSessionFilters(session_variable + '-other-data', 'Recent-Product-Page-No', '');

    // Remove highlight after delay
    setTimeout(function () {
      $targetElement.removeClass('tps-recent-viewed-ring');
    }, 1000);
  } else {
    console.warn("Target ring element not found: ", target);
  }
}




/*** End ***/

/*** Check Bulk Page Data Flag For Back TO Serach Diamonds start ***/
function translateFilterValues(filterValue, translationMap) {
  if (!filterValue) return '';
  return filterValue
    .split(',')
    .map(val => val.trim())
    .map(val => translationMap[val] || val)
    .join(',');
}

function getBulkPageDataValuesFromSession() {
  var bulk_page_data = 'no'; 
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Recent-Product-Page-No'] != undefined && session_other_data['Recent-Product-Page-No'][0] != ''){      
      var bulk_page_data = 'yes';
    }
  }
  return bulk_page_data;
}
/*** Check Bulk Page Data Flag For Back TO Serach Diamonds End ***/

/*** Get Product Grid View layout Start ***/ 
function getProductGridViewLayout(product, collectionHandel, diamondIndex) {
  var wishlistProducts = jQuery("#wishlist_products").val()?.split(",") || [];
  let banner_display_count = jQuery('#tps_banner_row_count').val();
  var diamond_index = (diamondIndex % 40) + 1;

  var pageNo = jQuery("#page_no").val();
  var metalFilter = jQuery("#setting_metal").val();
  var filteredMetal = metalFilter?.replace(/^18K\s/, '') || '';

  if (!filteredMetal) {
    // Try to get metal from GraphQL product object
    // Assuming product.metal is populated from GraphQL response (e.g., from metafield or options)
    filteredMetal = product.quality?.replace(/^18K\s/, '') || '';
  }

  // --- Product Data ---
  var produtSwaches = getProductSwatches(product, collectionHandel);
  var productVariant = getProductVariant(product, collectionHandel) || [];
  var variant = productVariant[0] || {};
  var currencySymbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    CAD: "$",
    AUD: "$",
    CHF: "CHF",
    INR: "₹",
    JPY: "¥"
  };
  // var productPrice = Shopify.formatMoney((product.finalPriceEur || 0) * 100, theme.moneyFormat);
  var productPrice = product.finalPriceEur + ' ' + currencySymbols[product.currency];

  // --- Images from GraphQL ---
  var defaultImage = 'https://cdn.shopify.com/s/files/1/0000/0000/0000/files/default-image.jpg';
  var getSizedImage = (img) => {
    if (!img) return defaultImage;
    return img.replace(/(\.jpe?g|\.png)$/i, '_300x300$1');
  };

  var productImage = getSizedImage(product.FullySetImage3 || product.image1);
  var productHoverImage = getSizedImage(product.FullySetImage2 || product.FullySetImage3 || product.FullySetImage4 || product.FullySetImage5 || product.FullySetImage1 || product.image2 || product.image3 || product.image1);

  // --- HTML Building ---
  let productGrid = '';

  productGrid += '<li class="tps-productlist-result-grid-view-item product-grid-row product-grid-item-' + product.ringId + '" data-id="' + product.productId + '" data-page="' + pageNo + '">';
  productGrid += '<div class="tps-productlist-item-media-div-section tps-productlist-item-media-div-' + product.ringId + '">';
  if (product.Video) {
    productGrid += '<div class="tps-setting-item-360-video-icon-span"><span class="tps-setting-item-video-icon">video</span></div>';
  }
  // productGrid += '<a href="' + (variant.url || product.url || '#') + '" data-id="' + product.ringId + '" data-page="1">';
  // productGrid += '<a onclick="openRingDetail(\'' + product.ringId + '\', \'' + (filteredMetal || '') + '\', \'' + (product.primaryStoneShape || '') + '\', \'' + (collectionHandel || '') + '\')" data-id="' + product.ringId + '" data-page="1">';
  productGrid += '<a href="#" onclick="event.preventDefault(); openRingDetail(\'' + product.productId + '\', \'' + (filteredMetal || '') + '\', \'' + (product.primaryStoneShape || '') + '\', \'' + (collectionHandel || '') + '\')" data-id="' + product.ringId + '" data-page="1">';
  productGrid += '<div class="tps-productlist-item-media-div">';
  productGrid += '<img class="tps-productlist-item-img tps-product-first-image" ' +
               'alt="' + (product.title || product.description || 'Product') + '" ' +
               'title="' + (product.title || product.description || 'Product') + '" ' +
               'src="' + productImage + '" width="300" height="300" ' +
               'onerror="this.src=\'' + defaultImage + '\'">';

  // --- Hover Image or Video ---
  if (product.Video) {
    productGrid += '<div class="tps-ringbuilder-video-360">';
    productGrid += '<video class="tps-productlist-item-img tps-product-second-image hover-video" width="300" height="300" autoplay muted loop playsinline>';
    productGrid += '<source src="' + product.Video + '" type="video/mp4">';
    productGrid += 'Your browser does not support the video tag.';
    productGrid += '</video>';
    productGrid += '</div>';
//     productGrid += '<div class="tps-ringbuilder-video-360">';
// productGrid += '<iframe width="300" height="300" src="' + product.Video + '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
// productGrid += '</div>';

  } else {
    productGrid += '<img class="tps-productlist-item-img tps-product-second-image" ' +
                 'alt="' + (product.title || product.description || 'Product') + '" ' +
                 'title="' + (product.title || product.description || 'Product') + '" ' +
                 'src="' + productHoverImage + '" width="300" height="300" ' +
                 'onerror="this.src=\'' + defaultImage + '\'">';
  }


  productGrid += '</div>';
  productGrid += '</a>';
  productGrid += '</div>';
  
  productGrid += '<div class="tps-productlist-item-wrapper">';
  productGrid += '<div class="tps-productlist-item-view-info tps-productlist-item-view-info-' + product.ringId + '">';
  // productGrid += '<a href="' + (variant.url || product.url || '#') + '" data-id="' + product.ringId + '" data-page="1">';
  productGrid += '<a href="#" onclick="event.preventDefault(); openRingDetail(\'' + product.productId + '\', \'' + (filteredMetal || '') + '\', \'' + (product.primaryStoneShape || '') + '\', \'' + (collectionHandel || '') + '\')" data-id="' + product.ringId + '" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-title">' + (product.title || product.description) + '</div>';
  productGrid += '<div class="tps-productlist-item-view-price">' + productPrice + '</div>';
  productGrid += '</a>';
  productGrid += '</div>';
  productGrid += '</div>';
  
  productGrid += '</li>';

  // --- Banner logic ---
  if (jQuery(window).width() > 900 && jQuery(window).width() < 1198) {
    banner_display_count = parseInt(banner_display_count) + 1;
  }

  if (diamond_index == banner_display_count) {
    var bannerHtml = $('#tps_banner_blog_' + pageNo).html();
    if (bannerHtml) {
      productGrid += `<li class="tps-diamondlist-banner-section">`;
      productGrid += '<div class="tps-diamond-listing-page-banner">' + bannerHtml + '</div>';
      productGrid += `</li>`;
    }
  }

  return productGrid;
}

/*** Get Product Grid View layout End ***/

/*** On Swatches Click Change Variant Data Start ***/
function changeProductData(productTitle,productId,variantId,variantTitle,variantPrice,variantImage,variantUrl,hoverImg) { 
  jQuery('.product-grid-item-'+productId+' .tps-productlist-item-swatch').removeClass('active');
  jQuery('.tps-productlist-item-swatch-'+variantId).addClass('active');
  jQuery('.tps-productlist-item-media-div-'+productId).addClass('tps-gallery-loading');   
  var productPrice = Shopify.formatMoney(variantPrice * 100, theme.moneyFormat);

  var productMedia = '';
  productMedia += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productMedia += '<div class="tps-productlist-item-media-div">';
  productMedia += '<img class="tps-productlist-item-img tps-product-first-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+variantImage+'" width="300" height="300">';
  if (hoverImg !== '' && hoverImg !== null && hoverImg !== undefined){
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+hoverImg+'" width="300" height="300">';
  }else{
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+variantImage+'" width="300" height="300">';
  } 
  productMedia += '</div>';
  productMedia += '</a>';  
  jQuery('.tps-productlist-item-media-div-'+productId).html(productMedia);  

  var productinfo = '';
  productinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productinfo += '<div class="tps-productlist-item-view-title">'+productTitle+'</div>';  
  productinfo += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>'; 
  productinfo += '</a>';
  jQuery('.tps-productlist-item-view-info-'+productId).html(productinfo);  
  jQuery('.tps-productlist-item-media-div-'+productId).removeClass('tps-gallery-loading');   
}
/*** On Swatches Click Change Variant Data End ***/

/*** Get variant Data After Filter Apply Start ***/
function getProductVariant(product,collectionHandel){
  var variantData = new Array();
  var shapeFilter = jQuery("#setting_shape").val();  
  var metalFilter = jQuery("#setting_metal").val(); 
  var productVariants = product.variants;
  var productHandle = product.handle;   
  var productMedia = product.images;
  var i = 0;

  if(productVariants != ''){
     $(productVariants).each(function(index, option){
       var variantShape = option.option1;
       var variantMetal = option.option2;
       
       if(shapeFilter == '' && metalFilter == ''){
         if(i == 0){
           variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
           
           i++;
         }
       }else if(shapeFilter != '' && metalFilter != ''){
         if(shapeFilter == variantShape && metalFilter == variantMetal){
           variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
            
         }
       }else if(shapeFilter == '' && metalFilter != ''){
         if(metalFilter == variantMetal){  
            if(i == 0){
              variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel); 
              
              i++;
            }              
         }
       }else if(shapeFilter != '' && metalFilter == ''){
         if(shapeFilter == variantShape){       
           if(i == 0){
             variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
              
             i++;
           }
         }
       }
     });
  }
  return variantData;   
}

function openRingDetail(productId, metal, shape, collectionHandle) {  
  var setting_metal = translateFilterValues(metal, metalTranslation);
  setting_metal = setting_metal || '';
  var setting_shape = translateFilterValues(shape, shapeTranslation);
  console.log("setting_metal",setting_metal)
  var postdata = JSON.stringify({
        query: `{
          ${ringDetailApi}(productId: "` + productId + `", shape: "` + setting_shape + `", metal: "` + setting_metal + `") {
            ringCount
            ring {
              ringId
              sku
              description
              shortDescription
              groupDescription
              merchandisingCategory1
              merchandisingCategory2
              merchandisingCategory3
              merchandisingCategory4
              merchandisingCategory5
              productType
              onhand
              status
              price
              showcasePrice
              currency
              unitOfSale
              Video
              finalPriceEur
              weightInDwt
              weightUnitOfMeasure
              gramWeight
              ringSizable
              ringSize
              ringSizeType
              leadTime
              productId
              designOption
              type
              jewelryState
              quality
              primaryStoneType
              primaryStoneShape
              primaryStoneSize
              secondaryStoneType
              finishedState
              readyToWear
              stoneMapImage
              diamondClarity
              diamondColor
              totalDiamondCaratWeight
              countryOfOrigin
              qualityCatalogValue
              creationDate
              updatedAt
              style
              image1
              image2
              image3
              FullySetImage1
              FullySetImage2
              FullySetImage3
              FullySetImage4
              FullySetImage5
          }
          ringVariantShapes
          ringVariantMetals
          }
        }`
      });

  jQuery.ajax({
    url: api,
    contentType: "application/json",
    type: 'POST',
    data: postdata,
    success: function (response) {
      console.log(response)
      var ringData = response?.data?.[ringDetailApi]?.ring;
      var ringId = ringData[0]?.ringId;
      var session_key = session_variable + '-other-data';
      var sessionData = localStorage.getItem(session_key);
      sessionData = sessionData ? JSON.parse(sessionData) : {};
      
      // Store new data
      sessionData["Ring-Id"] = [ringId];
      sessionData["Product-Id"] = [productId];
      
      // Save back to localStorage
      localStorage.setItem(session_key, JSON.stringify(sessionData));
      
      if (!ringData) {
        alert('Product details not found.');
        return;
      }

      setting_metal = setting_metal?.replace(/\s+/g, '_') || '';
      var productDetailUrl = '/pages/product-detail?productId=' + productId + '&shape=' + setting_shape + '&metal=' + setting_metal;

      // Navigate to detail page
      window.location.href = productDetailUrl;
    },
    complete: function () {
      jQuery(".tps-productlist-result-grid-view-loader").hide();
    }
  });
}

function getProductSelectedOption(option,productHandle,productMedia,collectionHandel){
   var variantInfo = new Array();
   var variantShape = option.option1;
   var variantMetal = option.option2;
   var varientImage = placeholderImageUrl.ring_placeholder;
   var varientFeaturedImage  = option.featured_image;
   
   if(varientFeaturedImage != null){
     varientImage = getImageByID(productMedia,option.featured_image.id);
     varientSecondImage = getSecondImageByID(productMedia,option.featured_image.id);
   } 
 
   var productUrl = '/collections/'+collectionHandel+'/products/'+productHandle+'?variant='+option.id+'&sku='+option.sku;
  
   variantInfo.push({
      id: option.id,
      sku: option.sku,
      shape: variantShape,
      metal: variantMetal,
      url: productUrl,
      image: varientImage,
      secondImage: varientSecondImage,
      price: option.price,
   });

  return variantInfo;
}
/*** Get variant Data After Filter Apply End ***/

/*** Get Product Swatches Data Start ***/
function getProductSwatches(product,collectionHandel){
   var swatchesData = new Array();
   var productVariants = product.variants;
   var productImages = product.images;
   var shapeFilter = jQuery("#setting_shape").val(); 
   var metalFilter = jQuery("#setting_metal").val();
  
   if(productVariants != ''){
     $(productVariants).each(function(index, option){          
         var variantShape = option.option1;
         var variantMetal = option.option2;
         var metalClass = variantMetal.toLowerCase();
         metalClass = metalClass.replace(/\s+/g,"-");         

         if(shapeFilter != '' && variantShape == shapeFilter){
             var active = '';
             if(metalFilter == variantMetal){
               var active = 'active'; 
             }
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;
             var imageUrl = getImageByID(productImages,option.featured_image.id);
             var varientSecondImage = getSecondImageByID(productImages,option.featured_image.id);
           
             swatchesData.push({
                id: option.id,
                sku: option.sku,
                metal: variantMetal,
                shape: variantShape,
                class: metalClass,
                url: productUrl,
                active: active,
                image: imageUrl,
                price: option.price,
                secondImage: varientSecondImage,
             });
         }else if(shapeFilter == ''){
             var active = '';
             if(metalFilter == variantMetal){
               var active = 'active'; 
             }
           
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;             
             var imageUrl = getImageByID(productImages,option.featured_image.id);
             var varientSecondImage = getSecondImageByID(productImages,option.featured_image.id);
           
             if(index <= 3){
               swatchesData.push({
                  id: option.id,
                  sku: option.sku,
                  metal: variantMetal,
                  shape: variantShape,
                  class: metalClass,
                  url: productUrl,
                  active: active,
                  image: imageUrl,
                  price: option.price,
                  secondImage: varientSecondImage,
               });
             }
         }
           
     });
   }
   return swatchesData;
}
/*** Get Product Swatches Data End ***/

/*** Get Image URL By Its ID Start ***/
function getImageByID(productImages,imageId) {
  var imageUrlArray = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });

  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/

/*** Get Image URL By Its ID Start ***/
function getSecondImageByID(productImages,imageId) {
  var imageUrlArray = new Array();
  var imageIndex = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){      
      var image_index = index+1;
      imageIndex.push(image_index);
    }

    if(imageIndex[0] == index){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });

  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/
  
/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/ 

/*** Onclick Product Store Product ID & PAge No in Session Start ***/
jQuery(document).on("click", ".tps-productlist-result-grid-view-item", function(e) {
  var data_page_no = $(this).attr("data-page");
  var data_product_id = $(this).attr("data-id");
  
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', data_page_no);
  updateSessionFilters(session_variable+'-other-data','Product-Id', data_product_id);
});
/*** Onclick Product Store Product ID & PAge No in Session End ***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyProductResultDiv(){   
  jQuery('.tps-productlist-result-grid-view-items-list').removeClass('tps-no-product-found');
  jQuery('.tps-productlist-result-grid-view-items-list').html('');
  var resetFlag = checkResetFlag();
  if(resetFlag != 'true'){
    ajaxDataCall();
  } 
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(){
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#setting_shape').val('');

    $('.tps-filter-metal-li').removeClass('selected');
    $(".tps-filter-metal-checkbox").prop('checked', false);
    $('#setting_metal').val('');

    $('.tps-filter-style-li').removeClass('selected');
    $(".tps-filter-style-checkbox").prop('checked', false);
    $('#setting_style').val('');

    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     

    $('.tps-sort-option').removeClass('active');
    $('.tps-sort-price-ascending').addClass('active');
    jQuery('.tps-sort-by-value').html('<span>'+translations.titlePriceSortLowToHigh+'</span>');
    jQuery('#sort_by').val('price-ascending');     

    updateSessionFilters(session_variable+'-other-data','Sort-By', 'price-ascending');
    updateSessionFilters(session_variable+'-other-data','Sort-Title', translations.titlePriceSortLowToHigh);
    
    jQuery('#page_no').val(1);
    ajaxDataCall();

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }

  // // Clear all query parameters from the URL
  // var baseUrl = window.location.origin + window.location.pathname;

  // // Store cleaned URL in global variable
  // tps_config_setting_listing = baseUrl;

  // // Update the URL in browser without reloading
  // window.history.replaceState({}, '', baseUrl);
  // console.log("tps_config_setting_listing",tps_config_setting_listing)
  // if (localStorage.getItem('tps_config_setting_listing') === null) {
  //     // Key doesn't exist – create it
  //     localStorage.setItem('tps_config_setting_listing', tps_config_setting_listing);
  //     console.log('Created localStorage key: tps_config_setting_listing');
  // } else {
  //     // Key exists – update its value
  //     localStorage.setItem('tps_config_setting_listing', tps_config_setting_listing);
  //     console.log('Updated localStorage key: tps_config_setting_listing');
  // }
  
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Reset Filter Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-tab2");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    jQuery(".tps-reset-filter-confirm-popup-div").hide();
  }
});
/*** Reset Filter Popoup Close Outer Click End ***/